import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { ValueService } from './services/value.service';
declare let $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'startup-tn-incubators';
  constructor(
    private router: Router,
    private titleService: Title,
    private getdata: ValueService
  ) {}

  /**
   * Initializes the component by showing a loader, setting up scroll event handlers,
   * and updating the browser title based on the router state.
   */
  ngOnInit() {
    // Show the loader animation
    this.getdata.amizhthLoader('show');

    // Hide the loader after 1 second
    setTimeout(() => {
      this.getdata.amizhthLoader('hide');
    }, 1000);

    // Document ready function to set up scroll event handlers
    $(document).ready(function () {
      // Show or hide 'back-to-top' button based on scroll position
      $(window).on('scroll', function () {
        if ($(this).scrollTop() > 100) {
          $('#back-to-top').fadeIn();
        } else {
          $('#back-to-top').fadeOut();
        }
      });

      // Smooth scroll to top when 'back-to-top' button is clicked
      $('#back-to-top').click(function () {
        $('html, body').animate(
          {
            scrollTop: 0,
          },
          600
        );
        return false;
      });
    });

    // Update the browser title based on the current router state
    this.RouterTitile();
  }
  /**
   * Updates the browser title based on the current router state.
   * Listens to router events and sets the document title according to the active route.
   */
  RouterTitile() {
    this.router.events
      .pipe(
        // Filter for NavigationEnd events to ensure title update occurs after routing
        filter((event) => event instanceof NavigationEnd),
        // Map the event to the router to access router state
        map(() => this.router)
      )
      .subscribe((event) => {
        // Retrieve the title from the router state and join with ' | ' for display
        const title = this.getTitle(
          this.router.routerState,
          this.router.routerState.root
        ).join(' | ');
        // Set the document title using the Title service
        this.titleService.setTitle(title);
      });
  }
  /**
   * Retrieves the title data from the router state.
   *
   * @param state - The current router state.
   * @param parent - The parent route snapshot.
   * @returns An array of titles collected from the route data.
   */
  getTitle(state, parent) {
    const data = [];

    // Check if the parent snapshot has a title in its data
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    // Recursively retrieve titles from child states
    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }

    return data;
  }
  /**
   * Displays the logout confirmation popup.
   * Hides any active loaders and shows the logout modal.
   */
  logoutPopup() {
    // Hide any active loaders
    this.getdata.amizhthLoader('hide');

    // Show the logout modal
    $('#logoutModal').modal('show');
  }
  /**
   * Logs the user out by clearing session storage, hiding the logout modal,
   * and navigating to the login page.
   */
  logout() {
    // Clear the session storage
    sessionStorage.clear();

    // Hide the logout modal
    $('#logoutModal').modal('hide');

    // Navigate to the login page
    this.router.navigateByUrl('/login');
  }
  guidelineDatas: any = [];
  /**
   * Opens the guidelines modal with the provided data.
   *
   * @param value - The guidelines data to be displayed in the modal.
   */
  guidelinesModal(value) {
    // Set the guideline data to be displayed in the modal
    this.guidelineDatas = value;
    // Show the guidelines modal
    $('#guidelinesModal').modal('show');
  }
  guidelineClose() {
    /**
     * Hides the guidelines modal.
     */
    $('#guidelinesModal').modal('hide');
    // Hide the modal
  }

  /**
   * Handles the update button action. Shows the update modal to allow the user
   * to update their profile information.
   */
  updateProfile() {
    // Show the update modal
    $('#updateModal').modal('show');
  }
  /**
   * Handles the update button action. Closes the update modal and navigates
   * to the appropriate route based on the provided value.
   *
   * @param value - The action value to determine the navigation route.
   */
  updateBtn(value) {
    // Hide the update modal
    $('#updateModal').modal('hide');

    // Navigate to the appropriate route based on the value
    if (value === 'Update') {
      this.router.navigateByUrl('/profile');
    } else {
      this.router.navigate(['admin', 'event', {}]);
    }
  }
}
